<div class="sidebar-inner">
    <div class="sidebar-scroll">
        <ul class="navbar-nav nav-sidebar" *ngFor="let menu of sidebarMenu">
          <li class="nav-item nav-togglebtn">
            <button id="sidebarToggle" (click)="openMenu()" class="btn btn-bars p-0">
              <i [ngClass]="status==true?'fa fa-times':'fa fa-bars'"></i>
            </button>
          </li>
          <li class="nav-item" (click)="activeLinks(menu.name)" [ngClass]="linkActive==menu.name?'active':''"><a
              [routerLink]="[menu.routerLink]" class="nav-link"><img
                src="{{menu.imageLink}}" alt="" class="icon">
              <span id="ep_dashboard">{{menu.title}}</span></a>
          </li>
        </ul>   
    </div>
  </div>

